export default function SectionApp() {
  return (
    <section id="app" className="w-full py-16 md:py-20 bg-background-100">
      <div className="w-full px-6 md:px-10">
        <div className="max-w-[1200px] mx-auto">
          <div className="bg-foreground-950 rounded-3xl overflow-hidden">
            <div className="flex flex-col lg:flex-row items-center">
              {/* Text */}
              <div className="flex-1 p-8 md:p-12 lg:p-14 text-center lg:text-left">
                <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full text-xs font-medium bg-accent-500/20 text-accent-400 mb-5 whitespace-nowrap">
                  <i className="ri-smartphone-line"></i> 随时随地吃瓜
                </span>
                <h2 className="font-heading text-3xl md:text-4xl text-background-50 mb-4">
                  黑料大赛 · 移动端
                </h2>
                <p className="text-sm md:text-base text-foreground-400 leading-relaxed mb-8 max-w-[480px]">
                  打开手机浏览器即可访问黑料大赛移动版，随时随地追踪最新八卦热度排行。支持 iOS 和 Android 系统，流畅浏览体验不打折。
                </p>
                <div className="flex items-center justify-center lg:justify-start gap-4 flex-wrap">
                  <a
                    href="#hero"
                    onClick={(e) => {
                      e.preventDefault();
                      document.querySelector('#hero')?.scrollIntoView({ behavior: 'smooth' });
                    }}
                    className="whitespace-nowrap inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold rounded-full text-sm transition-all duration-200 cursor-pointer no-underline"
                  >
                    <i className="ri-apple-line text-lg"></i>
                    iOS 版
                  </a>
                  <a
                    href="#hero"
                    onClick={(e) => {
                      e.preventDefault();
                      document.querySelector('#hero')?.scrollIntoView({ behavior: 'smooth' });
                    }}
                    className="whitespace-nowrap inline-flex items-center gap-2 px-6 py-3 bg-background-50/15 hover:bg-background-50/25 text-background-50 font-medium rounded-full text-sm border border-background-50/30 transition-all duration-200 cursor-pointer no-underline"
                  >
                    <i className="ri-android-line text-lg"></i>
                    Android 版
                  </a>
                </div>
              </div>
              {/* Preview */}
              <div className="flex-1 flex justify-center p-8 lg:p-0">
                <div className="relative w-[220px] h-[400px] md:w-[260px] md:h-[470px] rounded-3xl border-4 border-foreground-700 overflow-hidden shadow-2xl">
                  <img
                    src="https://readdy.ai/api/search-image?query=modern%20mobile%20phone%20screen%20mockup%20showing%20trending%20news%20ranking%20list%20interface%20with%20warm%20coral%20accents%20dark%20theme%20elegant%20UI%20design%20minimal%20clean%20layout%20content%20feed%20style&width=600&height=1200&seq=app-mockup-2026&orientation=portrait"
                    alt="黑料大赛移动端界面预览"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}